import MedianOmega from './MedianOmega';

export default MedianOmega;
